import {Component} from '@angular/core';
import { ApplicationsResultsService } from './_services/applications-results-service/applications-results.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'net2dg-gui';
  isSidebarOpen: boolean = true;

  constructor(private applicationsResultsService: ApplicationsResultsService) {
    // Initialize the sidebar state based on the service value
    this.applicationsResultsService.sidebarOpen$.subscribe(isOpen => {
      this.isSidebarOpen = isOpen;
    });

  }

}
